import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

export interface PageHeaderMainProps {
  children: ReactNode;
}

const PageHeaderMain: React.FC<PageHeaderMainProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: { xs: 1, sm: 2 },
        minHeight: 48,
      }}
    >
      {children}
    </Box>
  );
};

export default PageHeaderMain;
